const langDocumentSearch = {
	title: {
		tag: 'document.search.title',
		fr: 'Recherche avancée',
		en: 'More filters',
	},
};

export default langDocumentSearch;
